import { dateFormatter } from '@/helpers/dateFormatter'
import { Procedure as Data } from '@/typings/api/Procedure'

export const PASSPORT_DOWNLOAD = {
  action: 'open-modal',
  tooltip: 'Редактировать',
  icon: 'mdi-pencil',
}

export const TABLE_ACTIONS = Object.freeze([
  PASSPORT_DOWNLOAD,
])

export const TABLE_HEADERS = Object.freeze([
  {
    text: 'Наименование',
    value: 'name',
    sortable: false,
  },
  {
    text: 'Начало сбора',
    value: 'scan_start_at',
    sortable: false,
    field: (value: Data['scan_start_at']) => dateFormatter(value),
  },
  {
    text: 'Окончание сбора',
    value: 'scan_end_at',
    sortable: false,
    field: (value: Data['scan_end_at']) => dateFormatter(value),
  },
  {
    text: 'Сбор неполных комплектов',
    value: 'is_scan_incomplete_sets_allowed',
    sortable: false,
    field: (value: Data['is_scan_incomplete_sets_allowed']) =>
      value ? 'Активен' : 'Не активен'
  },
])
